import { TextField } from "@mui/material";
import styled from "styled-components";

export const StyledTextField = styled(TextField)`
   background-color: white !important;
  && {
    .MuiInputBase-input {
    background-color: white !important;
      &::placeholder {
        color: #999; /* Placeholder color */
      }
      '& .MuiOutlinedInput-root:focus .MuiOutlinedInput-notchedOutline': {
        color:'white;
        borderColor: 'white'; // Change focus outline color
      },
    }
    cursor: text;
  }
`;
